<template>
    <div class="attivita-container">
        <!-- Header dell'attività con pulsante Importa -->
        <div class="d-flex align-items-center p-3 bg-light rounded"
             :style="{ paddingLeft: (level * 1.5 + 0.75) + 'rem' }">
            <i v-if="hasSubItems"
               :class="expanded ? 'ph-caret-down' : 'ph-caret-right'"
               class="me-2 cursor-pointer"
               @click.stop="toggleExpanded()"></i>
            <i v-else class="me-2" style="width: 1em;"></i>

            <strong style="flex: 1;" class="cursor-pointer" @click.stop="toggleExpanded()">{{ attivita.TITOLO }}</strong>

            <div class="d-flex gap-2 align-items-center">
                <span v-if="hasVoci" class="badge bg-secondary">{{ attivita.VOCI.length }} {{ attivita.VOCI.length == 1 ? 'voce' : 'voci' }}</span>
                <span v-if="hasSottoAttivita" class="badge bg-info">{{ attivita.SOTTO_ATTIVITA.length }} {{ attivita.SOTTO_ATTIVITA.length == 1 ? 'sotto' : 'sotto' }}</span>
                <input type="checkbox"
                    :checked="selezionati.includes(attivita.ID_ATTIVITA)"
                    @change.stop="$emit('toggleSelezionato', attivita)"
                    @click.stop>
            </div>
        </div>

        <!-- Contenuto espanso -->
        <div v-if="expanded" :style="{ paddingLeft: (level * 1.5 + 0.75) + 'rem' }" class="expanded-content">
            <!-- Sottoattività -->
            <div v-if="hasSottoAttivita" class="sotto-attivita-container">
                <TabAttivitaImport
                    v-for="sotto in attivita.SOTTO_ATTIVITA"
                    :key="sotto.ID_ATTIVITA"
                    :attivita="sotto"
                    :filters="filters"
                    :level="level + 1"
                    :selezionati="selezionati"
                    @toggleSelezionato="$emit('toggleSelezionato', $event)"
                />
            </div>

            <!-- Voci -->
            <div v-if="hasVoci" class="mt-3 table-responsive">
                <table class="table table-sm table-hover mb-0">
                    <thead class="table-light">
                        <tr>
                            <th style="width: 30%">Titolo Voce</th>
                            <th style="width: 20%">Quantità</th>
                            <th style="width: 20%">Rip.</th>
                            <th style="width: 20%">Prezzo Unit.</th>
                            <th style="width: 20%">Totale</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="voce in attivita.VOCI" :key="voce.ID_VOCE">
                            <td>
                                <i class="ph-file-text me-1 text-muted"></i>
                                {{ voce.TITOLO_VOCE }}
                            </td>
                            <td>{{ voce.QUANTITY_PRICE || '-' }}</td>
                            <td>{{ voce.DAYS_PRICE || '-' }}</td>
                            <td>{{ filters.formattaImporto(voce.UNIT_PRICE) }}</td>
                            <td class="fw-bold">{{ filters.formattaImporto(voce.TOTAL_PRICE) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Messaggio se non c'è nulla -->
            <div v-if="!hasVoci && !hasSottoAttivita" class="text-muted p-2 mt-2">
                Nessun contenuto disponibile
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TabAttivitaImport",
    props: {
        attivita: {
            type: Object,
            required: true
        },
        filters: {
            type: Object,
            required: true
        },
        level: {
            type: Number,
            default: 0
        },
        selezionati: {
            type: Array,
            default: () => []
        }
    },
    emits: ['toggleSelezionato'],
    data() {
        return {
            expanded: false
        }
    },
    computed: {
        hasVoci() {
            return this.attivita.VOCI && this.attivita.VOCI.length > 0;
        },
        hasSottoAttivita() {
            return this.attivita.SOTTO_ATTIVITA && this.attivita.SOTTO_ATTIVITA.length > 0;
        },
        hasSubItems() {
            return this.hasVoci || this.hasSottoAttivita;
        }
    },
    methods: {
        toggleExpanded() {
            if (this.hasSubItems) {
                this.expanded = !this.expanded;
            }
        }
    }
}
</script>

<style scoped>
.attivita-container {
    margin-bottom: 0.5rem;
}

.expanded-content {
    margin-top: 0.5rem;
}

.sotto-attivita-container {
    margin-bottom: 0.75rem;
}

.cursor-pointer {
    cursor: pointer;
    transition: background-color 0.2s;
}

.cursor-pointer:hover {
    color: #0d6efd;
}
</style>
